export const typography = {
  fontFamily: "'Sofia Pro', sans-serif",
  fontSize: {
    xs: '10px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '24px',
    xxl: '36px'
  },
  fontWeight: {
    light: 100,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  lineHeight: {
    normal: 1,
    relaxed: 1.6
  }
}; 